<div class="delivery-step-container">
  <div class="delivery-step-progress">
    <div *ngFor="let step of stepData; let i = index; trackBy: trackByIndex" class="step-item">
      <!-- Circle with status -->
      <div
        class="step-circle"
        [ngClass]="{
          'step-completed': getStepStatus(i) === 'completed',
          'step-current': getStepStatus(i) === 'current',
          'step-pending': getStepStatus(i) === 'pending'
        }"
      ></div>

      <!-- Step label -->
      <div
        class="step-label"
        [ngClass]="{
          'label-completed': getStepStatus(i) === 'completed',
          'label-current': getStepStatus(i) === 'current',
          'label-pending': getStepStatus(i) === 'pending'
        }"
      >
        {{ step.label }}
      </div>

      <!-- Connection line (không hiển thị cho step cuối) -->
      <div
        *ngIf="i < stepData.length - 1"
        class="step-line"
        [ngClass]="{
          'line-completed': isLineCompleted(i),
          'line-pending': !isLineCompleted(i)
        }"
      ></div>
    </div>
  </div>
</div>
